import { getSiteProps } from "@/utils";

import { OptionsProps } from "../types/setting";

const host = typeof window !== "undefined" ? window.location.host : "";
const siteProps = getSiteProps(host);
const mediaUrl = siteProps?.media_url || "media.foundit.in";
export const getNotificationsData = (options: OptionsProps) => [
  {
    id: "jobNotification",
    name: "jobNotification",
    title: "Job Notifications",
    description:
      "Get Job recommendation, job alerts and notifications about your job application",
    showToggle: false,
    options: [
      {
        id: "jobNotification.recommendedJobs",
        name: "recommendedJobs",
        title: "Jobs recommended based on your profile and activity",
        value: options.recommendedJobs,
      },
      {
        id: "jobNotification.applicationStatus",
        name: "applicationStatus",
        title: "Receive updates on your application status",
        value: options.applicationStatus,
      },
      {
        id: "jobNotification.outreachSubscription",
        name: "outreachSubscription",
        title:
          "Receive Email notifications from recruiters regarding job opportunities that match your profile",
        value: options.outreachSubscription,
      },
    ],
  },
  {
    id: "profileRelatedNotification",
    name: "profileRelatedNotification",
    title: "Profile Related Notifications",
    description:
      "Gain insights into your profile views and receive tips to enhance your profile strength",
    showToggle: false,
    options: [
      {
        id: "profileRelatedNotification.profileViews",
        name: "profileViews",
        title: "Profile views",
        value: options.profileViews,
      },
      {
        id: "profileRelatedNotification.improveProfileStrength",
        name: "improveProfileStrength",
        title: "Improve profile strength",
        value: options.improveProfileStrength,
      },
    ],
  },
  {
    id: "whatsAppNotifications",
    name: "whatsAppNotifications",
    title: "WhatsApp Notifications",
    description:
      "Receive crucial updates from recruiters and job application notifications via WhatsApp",
    showToggle: true,
    value: options.whatsAppNotifications,
    icon: `https://${mediaUrl}/trex/search/public/images/whatsapp.svg`,
  },
  {
    id: "careerAdviceAndTips",
    name: "careerAdviceAndTips",
    title: "Career Advice and Tips",
    description:
      "Access the latest market information, industry trends, and tips & advice to advance your career",
    showToggle: true,
    value: options.careerAdviceAndTips,
  },
  {
    id: "promotionsAndSpecialOffers",
    name: "promotionsAndSpecialOffers",
    title: "Promotions and Special Offers",
    description:
      "Receive communication related to foundit paid services and other related services offered by foundit partner websites.",
    showToggle: true,
    value: options.promotionsAndSpecialOffers,
  },
];
